export default "__VITE_ASSET__DhydMHYk__"